import React from "react";
import "../css/returns.scss";

function Returns() {
  return (
    <div className="three-fourths columns medium-down--one-whole offset-by-two is-hidden-offset-mobile-only">
      <h1>Returns &amp; Refunds</h1>
      <div className="feature-divider" />
      <div className="rte">
        <p>We want your baplehollow order to arrive as described and in good condition.</p>
        <ul>
          <li>Contact <a href="mailto:model@baplehollow.online">model@baplehollow.online</a> within 14 days of delivery before sending an item back.</li>
          <li>Items must be unused, unworn and returned with their original packaging and any included parts. Hygiene-sensitive items cannot be returned after opening unless faulty.</li>
          <li>We will provide the correct return instructions and return location after approving the request. Do not send a parcel to an address shown elsewhere without authorisation.</li>
          <li>Return delivery costs are normally the customer’s responsibility for change-of-mind returns. Use a tracked service and keep the receipt.</li>
          <li>If an item arrives damaged, faulty or materially different from its description, send clear photos and your order number as soon as possible. Approved reasonable return costs will be reimbursed.</li>
          <li>Approved refunds are returned to the original payment method after inspection. Processing time depends on the payment provider.</li>
        </ul>
      </div>
    </div>
  );
}

export default Returns;
